import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from '@/components/ui/sonner'
import { ProtectedRoute } from '@/components/auth/protected-route'
import { ScrollNavigation } from '@/components/navigation/scroll-navigation'

// Layouts
import MarketingLayout from '@/layouts/MarketingLayout'
import AuthLayout from '@/layouts/AuthLayout'
import DashboardLayout from '@/layouts/DashboardLayout'
import ResellerLayout from '@/layouts/ResellerLayout'

// Pages
import HomePage from '@/pages/home/HomePage'
import ActivationPage from '@/pages/ActivationPage'
import UploadPlaylistPage from '@/pages/UploadPlaylistPage'
import PricingPage from '@/pages/PricingPage'
import PrivacyPage from '@/pages/PrivacyPage'
import TermsPage from '@/pages/TermsPage'
import SignInPage from '@/pages/auth/SignInPage'
import SignUpPage from '@/pages/auth/SignUpPage'
import PasswordResetPage from '@/pages/auth/PasswordResetPage'
import AuthCallbackPage from '@/pages/auth/AuthCallbackPage'
import DashboardPage from '@/pages/dashboard/DashboardPage'
import ResellerDashboardPage from '@/pages/reseller/ResellerDashboardPage'
import CreateClientPage from '@/pages/reseller/CreateClientPage'
import ActivationSuccessPage from '@/pages/ActivationSuccessPage'
import ResellerRegisterPage from '@/pages/reseller/RegisterPage'
import NotFoundPage from '@/pages/NotFoundPage'

function App() {
  return (
    <>
      <ScrollNavigation />
      <Toaster richColors theme="dark" position="top-right" />
      <Routes>
        {/* One home and one shared marketing shell. Old preview URLs only redirect. */}
        <Route path="/" element={<HomePage />} />
        {['/v1', '/v2', '/v3', '/v4'].map(path => <Route key={path} path={path} element={<Navigate to="/" replace />} />)}
        <Route element={<MarketingLayout />}>
          <Route path="/activation" element={<ActivationPage />} />
          <Route path="/activation/success" element={<ActivationSuccessPage />} />
          <Route path="/playlist" element={<UploadPlaylistPage />} />
          <Route path="/upload-playlist" element={<UploadPlaylistPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/reseller/register" element={<ResellerRegisterPage />} />
        </Route>

        {/* Auth Routes */}
        <Route path="/auth" element={<AuthLayout />}>
          <Route path="sign-in" element={<SignInPage />} />
          <Route path="sign-up" element={<SignUpPage />} />
          <Route path="password-reset" element={<PasswordResetPage />} />
          <Route path="auth-callback" element={<AuthCallbackPage />} />
        </Route>

        {/* Protected Dashboard Routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }>
          <Route index element={<DashboardPage />} />
        </Route>

        {/* Protected Reseller Routes */}
        <Route path="/reseller" element={
          <ProtectedRoute>
            <ResellerLayout />
          </ProtectedRoute>
        }>
          <Route path="dashboard" element={<ResellerDashboardPage />} />
          <Route path="clients/new" element={<CreateClientPage />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  )
}

export default App
